Number.prototype.clamp = function (min, max) {
    return Math.min(Math.max(this, min), max);
};

function PagingTemplate(totalPage, currentPage, functionName) {
    var template = "";
    var TotalPages = totalPage;
    var CurrentPage = currentPage;
    var PageNumberArray = Array();

    var countIncr = 1;
    var startPage;
    if (currentPage == 1) startPage = 1;
    else startPage = currentPage - 1;

    for (var i = startPage; i <= totalPage; i++) {
        PageNumberArray[0] = startPage;
        if (totalPage != currentPage - 1 && PageNumberArray[countIncr - 1] != totalPage) {
            PageNumberArray[countIncr] = i + 1;
        }
        countIncr++;
    };

    PageNumberArray = PageNumberArray.slice(0, 3);
    var FirstPage = 1;
    var LastPage = totalPage;
    var ForwardOne = 2;
    if (totalPage != currentPage) {
        ForwardOne = currentPage + 1;
    }
    var BackwardOne = 1;
    if (currentPage > 1) {
        BackwardOne = currentPage - 1;
    }

    if (currentPage != FirstPage) {
        template += '<li class="page-item"><a class="page-link" aria-label="First" onclick="' + functionName + '(' + FirstPage + ')' + '"><i class="fa-solid fa-angles-left" aria-hidden="true"></i><span class="sr-only">First</span></a></li>';
        template += '<li class="page-item"><a class="page-link" aria-label="Previous" onclick="' + functionName + '(' + BackwardOne + ')' + '"><i class="fa-solid fa-angle-left" aria-hidden="true"></i><span class="sr-only">Previous</span></a></li>';
    }

    for (var i = 0; i < PageNumberArray.length; i++) {
        template += '<li class="page-item' + (PageNumberArray[i] == currentPage ? " active" : "") + '"><a class="page-link" onclick="' + functionName + '(' + PageNumberArray[i] + ')' + '">' + PageNumberArray[i] + '</a></li>';
    }

    template += '<li class="page-item"><a class="page-link" aria-label="Next" onclick="' + functionName + '(' + ForwardOne + ')' + '"><i class="fa-solid fa-angle-right" aria-hidden="true"></i><span class="sr-only">Next</span></a></li>';
    template += '<li class="page-item"><a class="page-link" aria-label="Last" onclick="' + functionName + '(' + LastPage + ')' + '"><i class="fa-solid fa-angles-right" aria-hidden="true"></i><span class="sr-only">Last</span></a></li>';

    return template;
}